<template>
  <div>
    <div v-if="overlay" id="overlay"></div>

    <b-toast id="version_toast" title="Update available" toaster="b-toaster-bottom-right" body-class="text-center" variant="warning" solid no-auto-hide>
      <b-button class="m-2" variant="success" @click="reloadApp">Reload</b-button>
    </b-toast>
    <NavBar />
    <Alert />

    <div :class="['login', 'register', 'forgot-password', 'password_reset'].indexOf($route.name) === -1 ? 'content-wrapper' : ''">
      <router-view></router-view>
    </div>

    <Alert />
    <Confirm />
    <help-modal />

    <template v-if="$store.state.user.logged">
      <SidebarLeft />
      <SidebarRight />
      <UserMessage />

      <b-button v-b-toggle.sidebar-right variant="info" id="btn-sidebar-right" class="position-fixed" style="border-radius: 50% 0 0 50%;z-index: 1999;">
        <i class="far fa-comment-dots"></i>
        <b-badge v-if="$store.state.users.onlineUsers.length" variant="danger" style="position:absolute;top:2px;right:2px;">
          {{ $store.state.users.onlineUsers.length }}
        </b-badge>
      </b-button>
    </template>
  </div>
</template>

<script>
export default {
  name: 'App',
  mixins: [],
  props: {},
  components: {},
  data () {
    return {
      overlay: false,
      versionListen: null,
      presenceChannelListen: null,
      userChannelListen: null,
      user_message: '',
      user_message_title: '',
      user_id: null
    }
  },
  methods: {
    getUserData () {
      this.$store.dispatch('user/userinfo').then((response) => {
        console.log('userinfo ok')
      }).catch((error) => {
        if (error.response && error.response.data && error.response.data.message) {
          this.$root.$emit('showAlert', 'danger', error.response.data.message, 5)
          this.errors = error.response.data.errors || {}
        } else {
          this.$root.$emit('showAlert', 'danger', error.message, 5)
        }
      })
    },
    showMessage() {
      this.$bvToast.toast(this.user_message, {
        title: this.user_message_title,
        variant: 'info',
        solid: true,
        noAutoHide: true,
        bodyClass: 'text-center',
        toaster: 'b-toaster-bottom-right'
      })
    },
    subscribeToVersionChannel () {
      return new Promise((resolve, reject) => {
        if (!this.versionListen) {
          this.versionListen = Echo.channel('version-check')
            .listen('VersionChanged', (e) => {
              if (!localStorage.getItem('version') || e.version !== localStorage.getItem('version')) {
                localStorage.setItem('version', e.version)
                this.$bvToast.show('version_toast')
              }
            })

          resolve(true)
        } else {
          console.log('already subscribed version channel')
        }

        reject(new Error('Error subscribe to version channel'))
      })
    },
    subscribeToUserChannel () {
      return new Promise((resolve, reject) => {
        console.log('subscribe user channel')
        if (!this.userChannelListen && this.$store.state.user.user && this.$store.state.user.user._id) {
          this.user_id = this.$store.state.user.user._id
          // De facut si pe "pusher:subscription_error" ???
          this.userChannelListen = Echo.private('User.' + this.user_id)
            .on('pusher:subscription_succeeded', () => {
              console.log('connected user channel')
            })
            .on('pusher:unsubscribe', () => {
              this.userChannelListen = null
              console.log('out from user channel')
            })
            .listen('MessageToUser', (e) => {
              this.user_message_title = `${e.title} ${this.$t('from')} ${e.from}`
              this.user_message = e.message
              this.showMessage()
            })

          resolve(true)
        } else {
          reject(new Error('already subscribed user channel'))
        }
      })
    },
    subscribeToPresenceChannel () {
      return new Promise((resolve, reject) => {
        console.log('subscribe presence')
        if (!this.presenceChannelListen) {
          this.presenceChannelListen = Echo.join('Online')
            .here(users => {
              this.$store.commit('users/setOnlineUsers', users)
            })
            .joining(user => {
              this.$store.commit('users/addOnlineUsers', user)
            })
            .leaving(user => {
              this.$store.commit('users/remOnlineUsers', user)
            })
            .error((error) => {
              console.log(error)
              this.presenceChannelListen = null
              reject(new Error(error.message))
            })

          resolve(true)
        } else {
          console.log('already subscribed presence channel')
          this.unsubscribeToPresenceChannel().then(() => {
            this.subscribeToPresenceChannel()
            resolve(true)
          }).catch(() => { reject(new Error('Error subscribe to presence channel')) })
        }
      })
    },
    unsubscribeToVersionChannel () {
      return new Promise((resolve, reject) => {
        if (this.versionListen) {
          Echo.leave('version-check')
          this.versionListen = null
          console.log('leave version channel')
          resolve(true)
        }

        reject(new Error('Not subscribed to version channel'))
      })
    },
    unsubscribeToPresenceChannel () {
      return new Promise((resolve, reject) => {
        if (this.presenceChannelListen) {
          Echo.leave('Online')
          this.presenceChannelListen = null
          this.$store.commit('users/setOnlineUsers', [])
          console.log('leave presence channel')
          resolve(true)
        }

        resolve(false)
      })
    },
    unsubscribeToUserChannel () {
      return new Promise((resolve, reject) => {
        if (this.userChannelListen) {
          Echo.leave('User.' + this.user_id)
          this.user_id = null
          this.userChannelListen = null
          console.log('leave user channel')
          resolve(true)
        }

        resolve(false)
      })
    },
    reloadApp () {
      window.location.reload()
    },
    handler(event) {
      this.unsubscribeToUserChannel()
    },
    unsubscribeAll () {
      this.unsubscribeToVersionChannel()
      this.unsubscribeToUserChannel()
      this.unsubscribeToPresenceChannel()
    },
    checkMobileBrowser () {
      // return (typeof window.orientation !== 'undefined' || typeof screen.orientation !== 'undefined')
      return /Mobi/i.test(window.navigator.userAgent)
    },
    async askExit () {
      /* eslint-disable no-unused-vars */
      const answear = await new Promise((resolve) => {
        this.$root.$emit('askConfirmation', 'Close application?', resolve, true, true)
      }).then((response) => {
        if (response) {
          this.$root.exitApp()
        }
      })
      /* eslint-enable no-unused-vars */
    },
    async initSW() {
      await this.$store.dispatch('common/initSW')
        .then(async () => {
          console.log('SW DONE')
        }).catch(() => {
            console.log('initSW error')
        })
    }
  },
  computed: {
  },
  watch: {
    '$store.state.user.logged': function (newVal, oldVal) {
      if (newVal === true) {
        this.subscribeToPresenceChannel()
        this.subscribeToUserChannel()
      } else {
        this.unsubscribeToUserChannel()
        this.unsubscribeToPresenceChannel()
      }
    }
  },
  created () {
    window.addEventListener('beforeunload', this.handler)
  },
  async mounted () {
    document.addEventListener('deviceready', () => {
      this.$root.isMobileApp = true
      this.$nextTick(() => {
        document.addEventListener('backbutton', (evt) => {
          evt.preventDefault()
          this.askExit()
        }, false)
        //this.deviceReadyFunctions()
      })
    }, false)

    document.addEventListener('resume', () => {
      this.$root.isMobileApp = true
      this.$nextTick(() => {
        document.addEventListener('backbutton', (evt) => {
          evt.preventDefault()
          this.askExit()
        }, false)
        //this.deviceReadyFunctions()
      })
    }, false)

    this.checkMobileBrowser()

    if (this.$store.state.user.logged && this.$store.state.user.user === null) {
      this.getUserData()
    }

    await this.initSW()

    if (this.$store.state.user.logged === true) {
      this.subscribeToPresenceChannel()
      this.subscribeToUserChannel()
    }
    this.$root.$on('subscribeToPresenceChannel', () => { this.subscribeToPresenceChannel() })
    this.$root.$on('unsubscribeToPresenceChannel', () => { this.unsubscribeToPresenceChannel() })

    this.$root.$on('showOverlay', () => { this.overlay = true })
    this.$root.$on('hideOverlay', () => { this.overlay = false })

    this.subscribeToVersionChannel()

    this.$root.$on('disconnectUser', () => {
      this.unsubscribeToUserChannel()
      this.unsubscribeToPresenceChannel()
    })
  },
  beforeDestroy () {
    // window.removeEventListener('beforeunload', this.handler)
    this.unsubscribeAll()
  }
}
</script>

<style>
#overlay {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0,0,0,0.5);
  z-index: 1039;
}
</style>